export default "__VITE_ASSET__Dfap9bJn__"